export default {
  isActive: false,
  image: '/public/image/shirt_share.jpg',
  description: 'You are one step closer to making your one-of-a-kind T-shirt a reality.'
}
